import React from 'react';
import {DispatchOrder} from '../../types/DispatchOrder';
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {Constants} from "../common/Constants";
import {ActivitySubRows} from "./ActivitySubRows";
import {DispatchOrdersUtility} from "../common/DispatchOrdersUtility";

export let DispatchOrderListRow = function (props: {
    dispatchOrder: DispatchOrder,
    onClickDispatchOrderListRow: () => void,
    filterBrokerId?: any
}) {
    let dispatchOrder = props.dispatchOrder;
    let statusName = dispatchOrder.dispatch_order_status.name;
    if (statusName === Constants.dispatchOrderStatusNames.requested) {
        statusName = "Requested";
    } else if (statusName === Constants.dispatchOrderStatusNames.pending) {
        statusName = Constants.dispatchOrderStatusNames.pending;
    } else if (statusName === Constants.dispatchOrderStatusNames.confirmed) {
        statusName = Constants.dispatchOrderStatusNames.confirmed;
    } else if (statusName === Constants.dispatchOrderStatusNames.cancelled) {
        statusName = Constants.dispatchOrderStatusNames.cancelled;
    }

    let rowTruckCount = dispatchOrder.total_truck_count;
    let hasAnyPitHaul = (dispatchOrder.activities || []).some(function (activity) {
        return (activity.activity_broker_assignments || []).some(function (activityBrokerAssignment) {
            return activityBrokerAssignment.pit_haul;
        });
    });

    return (
        <div
            className={`dispatch-order-list-row ticket-list-row ${statusName.toLowerCase().replace(/\s+/g, "-")}`}
            data-dispatch-order-id={dispatchOrder.id}
            onClick={() => props.onClickDispatchOrderListRow()}
        >
            <div className="dispatch-order-list-row-content">
                <div className="ticket-list-row-left-edge">
                    <div className="ticket-list-row-left-edge-punch"></div>
                </div>

                <div className="ticket-list-row-body">
                    <div className="dispatch-order-row-left">
                        <div className="dispatch-order-row-cell dispatch-order-row-job-number-cell">
                            {dispatchOrder.job.job_number}
                        </div>

                        <div className="dispatch-order-row-cell dispatch-order-row-job-name-cell">
                            {dispatchOrder.job.name}
                        </div>

                        <div className="dispatch-order-row-cell dispatch-order-row-status-cell">
                            <div className="dispatch-order-row-status">
                                <div className="dispatch-order-row-status-dot"></div>
                                {dispatchOrder.dispatch_order_status.name}
                            </div>
                        </div>
                    </div>

                    <div className="dispatch-order-row-right">
                        <div className="dispatch-order-row-cell dispatch-order-row-activity-cell">
                            <div className="dispatch-order-row-activity">
                                <div className="dispatch-order-row-activity-list">
                                    <ActivitySubRows
                                        activities={dispatchOrder.activities}
                                        filterBrokerId={props.filterBrokerId}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="dispatch-order-row-cell dispatch-order-row-options">
                            <div className="dispatch-order-row-total-truck-count-cell">
                                <ConditionalRenderer
                                    if={rowTruckCount > 0 || hasAnyPitHaul}
                                    renderer={() => (
                                        <div className="dispatch-order-row-total-truck-count">
                                            {DispatchOrdersUtility.formatOrderTruckTotalDisplay(rowTruckCount, hasAnyPitHaul)}
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="dispatch-order-row-action-box">
                                <img
                                    className="dispatch-order-row-action-icon"
                                    src="/static/images/arrow-right-tiny-green.svg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
